import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";
import { DRAWER_WIDTH } from "src/utils/constants";

export const NavigationStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuItem: {
      backgroundColor: theme.palette.primary.main,
    },
    link: {
      textDecoration: "none",
    },
    icon: {
      color: "#fff",
    },
    drawer: {
      height: "100%", // or specify a fixed height
      overflowY: "auto",
      overflowX: "hidden",
      position: "relative",
      paddingRight: "8px", // Compensate for scrollbar width
      marginRight: "-8px", // Negative margin to offset padding

      // Modern browsers - overlay scrollbar
      "@supports (overflowY: overlay)": {
        overflowY: "overlay",
        paddingRight: 0,
        marginRight: 0,
      },

      // Webkit scrollbar styling (Chrome, Safari, newer Edge)
      "&::-WebkitScrollbar": {
        width: "8px",
        backgroundColor: "transparent",
      },

      "&::-WebkitScrollbarThumb": {
        backgroundColor: "rgba(179, 179, 179, 0.5)",
        borderRadius: "4px",
        "&:hover": {
          backgroundColor: "rgba(179, 179, 179, 0.7)",
        },
      },

      "&::-WebkitScrollbarTrack": {
        backgroundColor: "transparent",
      },

      // Firefox scrollbar styling
      scrollbarWidth: "thin",
      scrollbarColor: "rgba(179, 179, 179, 0.5) transparent",

      "& .MuiDrawer-paper": {
        width: DRAWER_WIDTH,
        backgroundColor: theme.palette.primary.main,
        border: "none",
        zIndex: 1201,
        overflow: "overlay",
      },
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
    mobileDialog: {
      "& .MuiDialog-paper": {
        backgroundColor: theme.palette.primary.main,
        border: "none",
      },
      backgroundColor: theme.palette.primary.main,
    },

    toolbar: {
      flexDirection: "row",
      alignItems: "flex-end",
      textAlign: "center",
      minHeight: "100px",
      justifyContent: "start",
      color: "#FFFFFF",
      padding: "0px 12px 26px 10px",
    },
    fontStyle: {
      fontSize: 16,
      color: "#fff",
      textDecoration: "none",
      textTransform: "none",
    },
    subFont: {
      fontSize: 14,
      color: "#fff",
      underline: "none",
    },
    Dividerstyle: {
      background: "silver",
    },
    boxsocial: {
      width: 60,
      height: 44,
    },
    mobileMenuStyles: {
      padding: "16px",
      [theme.breakpoints.up("md")]: {
        padding: "0px",
      },
    },
    Social: {
      paddingLeft: "16px",
      marginTop: "24px",
      marginBottom: "24px",
    },
    DrawerMenuComponent: {
      // marginBottom: "34vh",
      // position: "absolute",
      // bottom: "0",
    },
    Footer: {
      marginTop: "auto",
      width: "100%",
      position: "relative",
      bottom: "0",
    },
    FooterDesktop: {
      marginTop: "auto",
      width: "100%",
      "@media (max-height: 600px)": {
        position: "relative",
        overflow: "auto",
      },
      bottom: "0",
      padding: "16px",
      paddingBottom: "20px",
    },
    hide: {
      display: "none",
    },
  }),
);
